export const POST_TYPE_QUERY_PARAM = 'post_type'
export const CONTENT_MODULE_TYPE_QUERY_PARAM = 'content_type'
export const CONTENT_MODULE_ID_QUERY_PARAM = 'content_id'
export const RETURN_TO_QUERY_PARAM = 'return_to'
